import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const EMPTY = { acao: "", dimensao: "", responsavel: "", prazo: "", prioridade: "Média", status: "Pendente" };

export default function ActionModal({ assessmentId, dimensions, onClose, onSaved }) {
  const [form, setForm] = useState(EMPTY);
  const setF = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/action-plans", { ...form, assessment_id: assessmentId });
      toast.success("Ação adicionada");
      onSaved();
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-40 flex items-center justify-center p-4" onClick={onClose}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={submit}
            className="bg-white border w-full max-w-2xl p-8" data-testid="action-modal">
        <div className="overline mb-2">Plano de ação</div>
        <h2 className="font-display text-2xl font-extrabold mb-6 tracking-tight">Nova ação</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="label">Descrição da ação *</label>
            <textarea required value={form.acao} onChange={setF("acao")}
                      className="input min-h-[80px]" data-testid="action-field-desc" />
          </div>
          <div>
            <label className="label">Dimensão</label>
            <select value={form.dimensao} onChange={setF("dimensao")} className="input" data-testid="action-field-dim">
              <option value="">—</option>
              {dimensions.map((d) => <option key={d.dimensao}>{d.dimensao}</option>)}
            </select>
          </div>
          <div>
            <label className="label">Responsável</label>
            <input value={form.responsavel} onChange={setF("responsavel")} className="input" data-testid="action-field-resp" />
          </div>
          <div>
            <label className="label">Prazo</label>
            <input type="date" value={form.prazo} onChange={setF("prazo")} className="input" data-testid="action-field-prazo" />
          </div>
          <div>
            <label className="label">Prioridade</label>
            <select value={form.prioridade} onChange={setF("prioridade")} className="input" data-testid="action-field-prio">
              {["Baixa","Média","Alta","Crítica"].map((p) => <option key={p}>{p}</option>)}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button type="button" onClick={onClose} className="btn btn-secondary" data-testid="action-modal-cancel">Cancelar</button>
          <button type="submit" className="btn btn-primary" data-testid="action-modal-save">
            <i className="fa-solid fa-floppy-disk"></i> Salvar
          </button>
        </div>
      </form>
    </div>
  );
}
